import { Config } from '@comall-backend-builder/core/lib/parser';
import { PrecellOrder } from '../containers';

export let config: Config = {
    entities: {},
    components: {
        PrecellOrderView: {
            component: 'Card',
            title: '预售订单批次管理',
            content: {
                component: 'PrecellOrder',
            },
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/trade',
                    breadcrumbName: '交易管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/presellOrder',
                            component: 'Viewport',
                            breadcrumbName: '预售订单批次管理',
                            childRoutes: [
                                {
                                    path: '/',
                                    component: 'PrecellOrderView',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};
